// AUTOGENERATED
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const selectedOptionIsSymbol = {reflectSymbol: () => "selectedOption"};
const selectedValueIsSymbol = {reflectSymbol: () => "selectedValue"};
const SetCheckoutOptionIsSymbol = {reflectSymbol: () => "SetCheckoutOption"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const SetCheckoutOption = x => x;
const toFillFormTypeSetCheckout = {fillFormDataType: v => "unknown"};
const newtypeSetCheckoutOption_ = {Coercible0: () => {}};
const hasFieldSetCheckoutOption = dictHasField => dictHasField;
const eqSetCheckoutOption = {eq: x => y => x.selectedOption === y.selectedOption && x.selectedValue === y.selectedValue};
const genericSetCheckoutOption = {to: x => x, from: x => x};
const showSetCheckoutOption = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => ["{ selectedOption: " + Data$dShow.showStringImpl(v.selectedOption) + ", selectedValue: " + Data$dShow.showStringImpl(v.selectedValue) + " " + "}"]
    })(SetCheckoutOptionIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeSetCheckoutOption = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(selectedOptionIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(selectedValueIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeSetCheckoutOption = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericSetCheckoutOption)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(SetCheckoutOptionIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(selectedValueIsSymbol)(encodeWithOptionsOther))(selectedOptionIsSymbol)(encodeWithOptionsOther);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeSetCheckoutOption = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericSetCheckoutOption)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(SetCheckoutOptionIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(selectedValueIsSymbol)(decodeWithOptionsOther)())(selectedOptionIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  SetCheckoutOption,
  SetCheckoutOptionIsSymbol,
  decodeSetCheckoutOption,
  decodeWithOptionsOther,
  encodeSetCheckoutOption,
  encodeWithOptionsOther,
  eqSetCheckoutOption,
  genericSetCheckoutOption,
  hasFieldSetCheckoutOption,
  newtypeSetCheckoutOption_,
  selectedOptionIsSymbol,
  selectedValueIsSymbol,
  showSetCheckoutOption,
  toFillFormTypeSetCheckout,
  unscrambleDecodeSetCheckoutOption
};
